const Logo=()=>{
    return(
        <div className="border-5 border-top border-start border-m  wmc p-1 rounded-pill text-s-m">
            <div className="border-5 border-bottom border-end  border-m- wmc p-2 px-3 rounded-pill fs-5 fw-bold ">
                EFFECT
            </div>
        </div>
    )
}
export default Logo